class VimeoPlayerManager {

    static vimeoPlayer() {
        var iframe = document.querySelector('iframe');
        var player = new Vimeo.Player(iframe);

        function setPlaybackRateFromCache() {
            var savedPlaybackRate = localStorage.getItem('vimeoPlaybackRate');
            if (savedPlaybackRate) {
                player.setPlaybackRate(parseFloat(savedPlaybackRate)).then(function(rate) {

                }).catch(function(error) {
                    console.error('Error when set playback rate:', error);
                });
            }
        }

        function savePlaybackRateToCache(rate) {
            localStorage.setItem('vimeoPlaybackRate', rate);
        }

        function setVideoProgressFromCache() {
            if (iframe && iframe.dataset.vimeoPlaybackProgress) {
                const savedProgress = parseInt(iframe.dataset.vimeoPlaybackProgress);
                if (savedProgress) {
                    player.setCurrentTime(parseFloat(savedProgress)).catch(error => {
                        console.error('Error setting video time:', error);
                    });
                }
            }
        }

        function saveVideoProgress(seconds) {
            const progressUpdateUrl = iframe.dataset.progressUpdateUrl;
            $.ajax({
                url: progressUpdateUrl,
                method: 'PATCH',
                contentType: 'application/json',
                data: JSON.stringify({ progress: seconds }),
                error: function (xhr, status, error) {
                  console.error('Failed to save video progress', error);
                }
            });
        }

        if (iframe && iframe.src.includes('player.vimeo.com')) {
            setPlaybackRateFromCache();
            setVideoProgressFromCache();

            player.on('playbackratechange', function(event) {
                savePlaybackRateToCache(event.playbackRate);
            });

            player.on('timeupdate', event => {
                saveVideoProgress(event.seconds);
            });
        }
    }

}

export default VimeoPlayerManager;